// extracted by mini-css-extract-plugin
export default {"container":"moeF4s","image":"GC8Lc0","svg-container":"MDW9rd","svgContainer":"MDW9rd","svg":"zBDq7c","no-recipe":"SEjVSN","noRecipe":"SEjVSN"};